import React from 'react'
import Hero from './Hero'

function Home() {
    return (
        <div className='hero-wrapper'>
            <Hero />
        </div>
    )
}

export default Home
